module.exports = __webpack_public_path__ + "static/media/output_2.bc58f18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindRose/output_2.png
// module id = 2503
// module chunks = 0